import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import axios from "axios";
import Code from "components/SmallComponents/Code";
import StatusCapsule from "components/SmallComponents/StatusCapsule";
import Pagination from "pages/Pagination/Pagination";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { BsDownload } from "react-icons/bs";
import { FaCheck, FaEye, FaFilePdf } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import actionbuttonCustomStyle, {
  CustomOption,
} from "styles/actionbuttonCustomStyle.";
import Swal from "sweetalert2";
import fileExtensionMap from "utils/fileExtension";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const DebitNoteList = forwardRef(
  (
    {
      searchParameter,
      searchParameter2,
      searchCompanySpecificCriteriaId,
      searchCompanySpecificDateRangeId,
      formDate,
      toDate,
    },
    ref
  ) => {
    const [debitNoteList, setdebitNoteList] = useState([]);
    const gridRef = useRef();
    const data = useRef([]);
    const selectRef = useRef();
    const [inventoryMovement, setInventoryMovement] = useState(false);
    const [submitObj, setSubmitObj] = useState({
      id: "",
      company_warehouse_id: "",
      fin_credit_note_status_id: 2,
      inventory_movement: false,
    });
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [wareHouse, setWareHouse] = useState([]);
    const [erplist, setErplist] = useState([]);
    const token = sessionStorage.getItem("token");
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    useEffect(() => {
      // Retrieving data from sessionStorage
      const storedErplist = sessionStorage.getItem("erplist");
      if (storedErplist) {
        try {
          // Parsing the JSON string to an array of objects
          const parsedErplist = JSON.parse(storedErplist);
          setErplist(parsedErplist);
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }
      }
    }, []);

    const [count, setCount] = useState();
    const [recordPerPage, setRecordPerPage] = useState(200);
    const [page, setPage] = useState(1);
    const [offsetforSR, setOffsetforSR] = useState();
    // const [searchParameter, setsearchParameter] = useState("");

    useEffect(() => {
      companywarehouseget();
    }, []);

    useEffect(() => {
      getDebitNote();
    }, [
      searchParameter,
      searchParameter2,
      searchCompanySpecificCriteriaId,
      searchCompanySpecificDateRangeId,
      page,
      recordPerPage,
    ]);

    const showActionColumn = erplist.some(
      (item) => item.erp_module_id === 60 && item.update
    );

    const showViewColumn = erplist.some(
      (item) => item.erp_module_id === 60 && item.update
    );

    const updatedActionButtonCustomStyle = {
      ...actionbuttonCustomStyle,
      control: (base) => ({
        ...base, // Spread the existing `control` styles
        backgroundColor: "transparent",
        border: "none",
        boxShadow: "none",
        cursor: "pointer",
        width: "150px", // Set the desired width here
        "&:hover": {
          border: "none",
        },
      }),
      menu: (base) => ({
        ...base,
        marginTop: "0px", // Space above the menu
        marginRight: "100px", // Space on the right of the menu
        marginBottom: "0", // Space below the menu
        marginLeft: "0px", // Space on the left of the menu
        paddingTop: "0", // Space inside the top of the menu container
        paddingRight: "0", // Space inside the right of the menu container
        paddingBottom: "0", // Space inside the bottom of the menu container
        paddingLeft: "0", // Space inside the left of the menu container
        zIndex: 9999,
      }),
    };

    const getDebitNote = () => {
      var offset = (page - 1) * recordPerPage;
      setOffsetforSR((page - 1) * recordPerPage);
      var limit = recordPerPage;
      console.log(offset);

      const requestPayload = {
        // Include other properties from obj
        offset,
        limit,
        search_company_specific_criteria_id: searchCompanySpecificCriteriaId,
        search_company_specific_date_range_id: searchCompanySpecificDateRangeId,
        search_parameter: searchParameter || searchParameter2,
      };
      console.log(requestPayload);

      axios
        .post(
          "/api/purple-fusion/debitnote/getforpagging",
          requestPayload,
          headers
        )
        .then((response) => {
          console.log(response.data);
          const sortedData = [...response.data].sort((a, b) => b.id - a.id);
          setCount(response.data[0]?.count);
          setdebitNoteList(sortedData);
          data.current = sortedData;
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    const companywarehouseget = () => {
      axios
        .post("/api/purple-fusion/companywarehouse/get", {}, headers)
        .then((response) => {
          // Assuming response.data is an array of warehouse objects
          const formattedOptions = response.data.map((warehouse) => ({
            value: warehouse.id, // Use a unique identifier
            label: warehouse.warehouse_name, // Use a meaningful display name
          }));

          setWareHouse(formattedOptions);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    useImperativeHandle(
      ref,
      () => ({
        downloadExcel: () => {
          onBtnExport();
        },

        downloadPdf: () => {
          DownloadPDF();
        },
      }),
      []
    );

    const DownloadPDF = () => {
      const docDefinition = {
        pageOrientation: "portrait",
        header: {
          text: "Debit Note List",
          style: "header",
        },
        content: [
          {
            style: "tableExample",
            table: {
              body: [
                [
                  { text: "SNO.", style: "tableHeader", bold: true },
                  { text: "SUPPLIER NAME", style: "tableHeader", bold: true },
                  {
                    text: "PURCHASE INVOICE CODE",
                    style: "tableHeader",
                    bold: true,
                  },
                  {
                    text: "DEBIT NOTE CODE",
                    style: "tableHeader",
                    bold: true,
                  },
                  {
                    text: "CREDIT NOTE NUMBER",
                    style: "tableHeader",
                    bold: true,
                  },
                  { text: "STATUS", style: "tableHeader", bold: true },
                  {
                    text: "REASON FOR DEBIT NOTE",
                    style: "tableHeader",
                    bold: true,
                  },
                  {
                    text: "DEBIT NOTE DATE",
                    style: "tableHeader",
                    bold: true,
                  },
                  { text: "ACTIVE", style: "tableHeader", bold: true },
                  { text: "CREATED DATE", style: "tableHeader", bold: true },
                ],
                ...(data.current?.map((debitNote, index) => [
                  index + 1, // SNO.
                  debitNote.supplier_name || "",
                  debitNote.company_purchase_order_code || "",
                  debitNote.code || "",
                  debitNote.credit_note_number || "",
                  debitNote.fin_debit_note_status || "",
                  debitNote.reason_for_debit_note || "",
                  debitNote.debit_note_date || "",
                  debitNote.isactive ? "Yes" : "No",
                  debitNote.createdon || "",
                ]) || []),
              ],
              widths: "auto",
            },
            layout: {
              fillColor: function (rowIndex, node, columnIndex) {
                return rowIndex === 0 ? "#CCCCCC" : null;
              },
            },
          },
        ],
        styles: {
          tableExample: {
            fontSize: 8, // Set the font size to a smaller value
            color: "#333",
          },
          tableHeader: {
            bold: true,
            fontSize: 10, // You can set a different font size for headers if needed
            color: "#000",
          },
          header: {
            fontSize: 18,
            bold: true,
            margin: [10, 10, 10, 20],
            // Add underline
            color: "#333",
          },
        },
      };
      pdfMake.createPdf(docDefinition).download("Debit Note List");
    };

    const onBtnExport = useCallback(() => {
      const excludedFields = ["id"]; // Fields to exclude from the export

      const visibleColumns = customColDefs.filter(
        (column) => !excludedFields.includes(column.field)
      );

      const options = {
        fileName: "Debit Note List.csv", // Specify your desired filename here
        columnKeys: visibleColumns.map((column) => column.field),
        processCellCallback: (params) => {
          if (params.column.getColId() === "isactive") {
            return params.value ? "Yes" : "No";
          }
          return params.value;
        },
      };
      // Export data with updated options
      gridRef.current.api.exportDataAsCsv(options);
    }, []);

    const handleDownloadSupplierCreditNote = async (params) => {
      try {
        const requestData = { id: params };

        const response = await axios.post(
          "/api/purple-fusion/debitnote/downloads",
          requestData,
          {
            ...headers,
            responseType: "arraybuffer",
          }
        );

        const contentType = response.headers["content-type"];

        const fileExtension = fileExtensionMap[contentType] || "bin"; // fallback to .bin
        const fileName = `SupplierCreditNote.${fileExtension}`;

        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    };

    const handleDownloadOriginalDebitNote = async (params) => {
      console.log(params);
      try {
        const requestData = {
          fin_debit_note_id: params.data.id,
          fin_debit_note_document_type_id: 1, // Original Copy
        };

        const response = await axios.post(
          "/api/purple-fusion/debitnote/pdf/downloads",
          requestData,
          {
            ...headers,
            responseType: "arraybuffer",
          }
        );

        const contentDisposition = response.headers["content-disposition"];
        const FileName = response.headers["content-disposition"];
        const contentType = response.headers["content-type"];

        // Extract file name from content disposition
        const fileNameMatch = contentDisposition.match(
          /filename=["']?([^'"\s]+)["']?/
        );
        const fileName = fileNameMatch ? fileNameMatch[1] : "download";

        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: contentType });

        // Create a URL for the file
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${params.data.code}.pdf`; // Use the extracted filename directly
        document.body.appendChild(a);

        // Trigger a click event to start the download
        a.click();

        // Remove the download link from the DOM
        document.body.removeChild(a);

        // Revoke the Object URL to free up resources
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    };
    const handleDownloadAllCopyDebitNote = async (params) => {
      console.log(params);
      try {
        const requestData = {
          fin_debit_note_id: params.data.id,
          fin_debit_note_document_type_id: 5, // All Copy
        };

        const response = await axios.post(
          "/api/purple-fusion/debitnote/pdf/downloads",
          requestData,
          {
            ...headers,
            responseType: "arraybuffer",
          }
        );

        const contentDisposition = response.headers["content-disposition"];
        const FileName = response.headers["content-disposition"];
        const contentType = response.headers["content-type"];

        // Extract file name from content disposition
        const fileNameMatch = contentDisposition.match(
          /filename=["']?([^'"\s]+)["']?/
        );
        const fileName = fileNameMatch ? fileNameMatch[1] : "download";

        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: contentType });

        // Create a URL for the file
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${params.data.code}.pdf`; // Use the extracted filename directly
        document.body.appendChild(a);

        // Trigger a click event to start the download
        a.click();

        // Remove the download link from the DOM
        document.body.removeChild(a);

        // Revoke the Object URL to free up resources
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    };

    const GetPreview = async (params, name) => {
      console.log(name);
      try {
        const requestData = {
          id: params,
        };
        console.log(requestData);

        const response = await axios.post(
          "/api/purple-fusion/debitnote/preview",
          requestData,
          {
            ...headers,
            responseType: "arraybuffer",
          }
        );
        // const contentDisposition = response.headers["content-disposition"];
        const FileName = response.headers["content-disposition"];

        // const contentType = response.headers["content-type"];
        const contentType = "application/pdf";
        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: contentType });

        // Check if the Blob type is supported before creating an Object URL
        if (Blob.prototype.hasOwnProperty("arrayBuffer")) {
          const arrayBuffer = await blob.arrayBuffer();
          const url = window.URL.createObjectURL(
            new Blob([arrayBuffer], { type: contentType })
          );

          // Open a new tab and set its location to the Object URL
          window.open(url);

          // Revoke the Object URL to free up resources
          window.URL.revokeObjectURL(url);
        } else {
          console.error(
            "Blob.arrayBuffer is not supported. Unable to create Object URL."
          );
        }
      } catch (error) {
        console.error("Error downloading file:", error);
        toast.warning("Unable to download file. Please try again later.");
      }
    };

    const deleteDraftTaxInvoice = (id) => {
      Swal.fire({
        title: "Are you sure?",
        html: `You want to delete 
        <span style="color: #FF5733;"></span>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      })
        .then((result) => {
          if (result.isConfirmed) {
            axios
              .put(
                "/api/purple-fusion/debitnote/deletedraftnote",
                { id: id },
                headers
              )
              .then((response) => {
                console.log(response.data);
                const message = response.data.message;
                if (response.data.status) {
                  toast.success(message, {
                    autoClose: 1000,
                  });
                  getDebitNote();
                } else {
                  toast.error(message, {
                    autoClose: 1000,
                  });
                }
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const handleSubmit = (obj) => {
      console.log("Submit clicked with:", obj);

      // if (obj.inventory_movement && !obj.company_warehouse_id) {
      //   toast.error("Please select a warehouse", {
      //     autoClose: 2000,
      //   });
      //   return;
      // }

      axios
        .put("/api/purple-fusion/debitnote/update", obj, headers)
        .then((response) => {
          console.log(response.data);
          const message = response.data.message;
          response.data.status
            ? toast.success(message, {
                autoClose: 2000,
                onClose: () => {
                  setIsOpen(false);
                  getDebitNote();
                },
              })
            : toast.error(message, {
                autoClose: 2000,
                onClose: () => {},
              });
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const handleNavigation = (option) => {
      console.log("Navigate to:", option.value);
      const params = option.params;

      switch (option.value) {
        case "View":
          navigate(`/debitnote/item/${params.data.id}`, {
            state: {
              company_purchase_order_id: params.data.company_purchase_order_id,
            },
          });
          break;
        case "Preview":
          GetPreview(params.data.id, params.data.code);
          break;
        case "Delete":
          deleteDraftTaxInvoice(params.data.id);
          break;
        case "Submit":
          const updatedObj = {
            ...submitObj,
            id: params.data.id,
            fin_debit_note_status_id: 2,
            inventory_movement: params.data.inventory_movement,
          };
          setSubmitObj(updatedObj); // keep your state updated
          handleSubmit(updatedObj); // pass the correct data
          break;
        case "Download Credit Note":
          handleDownloadSupplierCreditNote(params.data.id);
          break;
        case "DownloadOriginal":
          handleDownloadOriginalDebitNote(params);
          break;
        case "DownloadAllCopy":
          handleDownloadAllCopyDebitNote(params);
          break;
        default:
          break;
      }
    };

    const defaultColDefs = [
      { headerName: "SNO.", field: "sr", width: 80 },
      { headerName: "SUPPLIER NAME", field: "supplier_name", width: 200 },
      {
        headerName: "PURCHASE INVOICE CODE",
        field: "company_purchase_order_code",
        width: 150,
      },
      {
        headerName: "DEBIT NOTE CODE",
        field: "code",
        width: 150,
        cellRenderer: (params) => <Code>{params.value}</Code>,
      },
      {
        headerName: "CREDIT NOTE NUMBER",
        field: "credit_note_number",
        width: 120,
        cellClass: "font-semibold",
      },
      {
        headerName: "STATUS",
        field: "fin_debit_note_status",
        width: 130,
        cellRenderer: (params) => (
          // <>
          //   {params.data.fin_debit_note_status === "Submitted" ? (
          //     <span class=" text-green-500 ">{params.value}</span>
          //   ) : (
          //     <span class=" text-red-500  ">{params.value}</span>
          //   )}
          // </>
          <>
            <StatusCapsule
              type={
                params.data.fin_debit_note_status === "Submitted"
                  ? "success"
                  : "error"
              }
            >
              {params.value}
            </StatusCapsule>
          </>
        ),
      },
      {
        headerName: "REASON FOR DEBIT NOTE",
        field: "reason_for_debit_note",
        width: 200,
      },
      {
        headerName: "DEBIT NOTE DATE",
        field: "debit_note_date",
        width: 120,
      },
      { headerName: "ACTIVE", field: "isactive", width: 120 },
      {
        headerName: "CREADED DATE",
        field: "createdon",
        width: 120,
      },
      {
        headerName: "CREDIT NOTE",
        field: "fin_supplier_credit_note_id",
        cellRenderer: (params) =>
          params.data.fin_supplier_credit_note_id ? (
            <button
              className="font-small text-blue-600 dark:text-blue-500 "
              onClick={(e) => {
                handleDownloadSupplierCreditNote(params.value);
              }}
              title="ORIGINAL COPY"
            >
              {/* Download One  */}
              <BsDownload className="w-4 h-4" />
            </button>
          ) : null,
        width: 120,
      },
      {
        headerName: "DELETE",
        field: "id",
        cellRenderer: (params) =>
          params.data.fin_debit_note_status === "Draft" ? (
            <button
              className="font-small"
              onClick={(e) => {
                deleteDraftTaxInvoice(params.value);
              }}
              title="Delete"
            >
              <MdDelete className="w-4 h-4" color="red" />
            </button>
          ) : null,
        width: 100,
      },
      {
        headerName: "SUBMIT",
        field: "id",
        cellRenderer: (params) =>
          params.data.fin_debit_note_status === "Draft" ? (
            <div className="my-1 flex justify-center items-center gap-2">
              <button
                onClick={() => {
                  const updatedObj = {
                    ...submitObj,
                    id: params.data.id,
                    fin_debit_note_status_id: 2,
                    inventory_movement: params.data.inventory_movement,
                  };
                  setSubmitObj(updatedObj); // keep your state updated
                  handleSubmit(updatedObj); // pass the correct data
                }}
                className="bg-transparent hover:bg-green-500 p-1 hover:text-black-900 text-blue-700 font-semibold hover:text-white border border-blue-500 hover:border-transparent rounded"
              >
                Submit
              </button>
            </div>
          ) : null,
        width: 100,
      },

      {
        headerName: "DEBIT NOTE",
        field: "id",
        cellRenderer: (params) =>
          params.data.fin_debit_note_status_id === 2 ? (
            <button
              className="font-small text-blue-600 dark:text-blue-500 "
              onClick={(e) => {
                handleDownloadOriginalDebitNote(params);
              }}
              title="ORIGINAL COPY"
            >
              {/* Download One  */}
              <BsDownload className="w-4 h-4" />
            </button>
          ) : null,
        width: 120,
      },

      {
        headerName: "ACTIONS",
        field: "code",
        pinned: "right",
        cellRenderer: (params) => {
          const { showActionColumn, showViewColumn } = params.context;
          const {
            fin_debit_note_status,
            fin_debit_note_status_id,
            fin_supplier_credit_note_id,
          } = params.data;
          const getOptions = () => {
            let options = [];

            options.push({
              value: "Preview",
              label: "Preview",
              iconColor: "rgb(239 68 68)", // Set the icon color
              labelColor: "rgb(59 130 246)", // Set the label color
              icon: FaFilePdf,
              params: params,
            });
            if (showViewColumn) {
              options.push({
                value: "View",
                label: "View items",
                iconColor: "rgb(59 130 246)", // Set the icon color
                labelColor: "rgb(59 130 246)", // Set the label color
                icon: FaEye,
                params: params,
              });
            }
            // console.log(showActionColumn);
            if (showActionColumn && fin_debit_note_status === "Draft") {
              options.push({
                value: "Submit",
                label: "Submit",
                iconColor: "rgb(34 197 94)", // Set the icon color
                labelColor: "rgb(34 197 94)", // Set the label color
                icon: FaCheck,
                params: params,
              });
            }

            if (showActionColumn && fin_debit_note_status_id === 1) {
              options.push({
                value: "Delete",
                label: "Delete",
                iconColor: "rgb(239 68 68)", // Set the icon color
                labelColor: "rgb(239 68 68)", // Set the label color
                icon: RiDeleteBin6Line,
                params: params,
              });
            }
            if (fin_debit_note_status_id === 2) {
              options.push({
                value: "DownloadOriginal",
                label: "Download Original Copy",
                iconColor: "rgb(59 130 246)", // Set the icon color
                labelColor: "rgb(59 130 246)", // Set the label color
                icon: BsDownload,
                params: params,
              });
              options.push({
                value: "DownloadAllCopy",
                label: "Download All Copy",
                iconColor: "rgb(59 130 246)", // Set the icon color
                labelColor: "rgb(59 130 246)", // Set the label color
                icon: BsDownload,
                params: params,
              });
            }

            if (fin_supplier_credit_note_id) {
              options.push({
                value: "Download Credit Note",
                label: "Download Credit Note",
                iconColor: "rgb(59 130 246)", // Set the icon color
                labelColor: "rgb(59 130 246)", // Set the label color
                icon: BsDownload,
                params: params,
              });
            }

            return options;
          };

          const options = getOptions();

          return (
            <div style={{ width: "100%", position: "relative", zIndex: 999 }}>
              <Select
                options={options}
                isSearchable={false}
                onChange={handleNavigation}
                placeholder={params.value || "ACTION"}
                menuPlacement="bottom"
                menuPortalTarget={selectRef.current} // Render the menu in the body
                // styles={actionbuttonCustomStyle}
                styles={updatedActionButtonCustomStyle}
                value={null} // Ensure no value is selected
                components={{ Option: CustomOption }} // Use the custom option component
              />
            </div>
          );
        },
        width: 180,
      },
    ];

    const customColDefs = [
      ...defaultColDefs,
      {
        headerName: "Actions",
        field: "id",
        cellRenderer: (params) => (
          <button
            className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
            onClick={() => {
              navigate(`/debitnote/item/${params.value}`, {
                state: {
                  company_purchase_order_id:
                    params.data.company_purchase_order_id,
                },
              });
            }}
          >
            <FaEye />
          </button>
        ),
        width: 100,
        filter: false,
      },
    ];
    const [colDefs, setColDefs] = useState([]);
    useEffect(() => {
      setColDefs(showActionColumn ? customColDefs : defaultColDefs);
    }, [showActionColumn]);
    const ColDefaultVale = { filter: true };

    const gridOptions = {
      overlayNoRowsTemplate: `
        <div id="progress-bar-id" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
        </div>
    `,
    };
    return (
      <>
        {erplist.some((item) => item.erp_module_id === 60 && item.view) ? (
          <div>
            <ToastContainer />
            <div
              className="ag-theme-quartz"
              id="tab-grid-table"
              ref={selectRef}
            >
              <AgGridReact
                ref={gridRef}
                rowData={debitNoteList.map((debitNoteList, index) => ({
                  ...debitNoteList,
                  sr: index + (offsetforSR + 1),
                }))}
                context={{ showActionColumn, showViewColumn }} // Pass `showActionColumn` through context
                columnDefs={colDefs}
                defaultColDef={ColDefaultVale}
                suppressMenuHide={true}
                suppressExcelExport={true}
                rowHeight={37}
                overlayLoadingTemplate={loading ? "Loading..." : null}
                overlayNoRowsTemplate={
                  loading
                    ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                    : "No Record Found"
                }
              />
            </div>
            <div>
              <Pagination
                count={count}
                setRecordPerPage={setRecordPerPage}
                recordPerPage={recordPerPage}
                setLoading={setLoading}
                setData={setdebitNoteList}
                setPage={setPage}
                page={page}
              />
            </div>
            {isOpen && (
              <WearHouseSelect
                options={wareHouse}
                setSubmitObj={setSubmitObj} // pass this
                submitObj={submitObj} // pass this if needed
                setInventoryMovement={setInventoryMovement}
                inventoryMovement={inventoryMovement}
                handleSubmit={handleSubmit}
                setIsOpen={setIsOpen}
              />
            )}
          </div>
        ) : (
          <div className="flex justify-center items-center h-screen">
            <div className="text-4xl text-red-500">No Access</div>
          </div>
        )}
      </>
    );
  }
);

const WearHouseSelect = ({
  options,
  onChange,
  handleSubmit,
  setIsOpen,
  inventoryMovement,
  setInventoryMovement,
  setSubmitObj,
  submitObj,
}) => {
  const [visible, setvisible] = useState(true);
  const customStyle = {
    content: {
      width: "40%",
      height: "40%",
      margin: "auto",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  };
  return (
    <>
      <Modal isOpen={visible} style={customStyle} onRequestClose={() => {}}>
        <div className="flex flex-col h-full gap-5 justify-center ">
          <Select
            options={options}
            onChange={(selectedOption) => {
              onChange?.(selectedOption); // optional, for other logic
              setSubmitObj((prev) => ({
                ...prev,
                company_warehouse_id: selectedOption.value,
              }));
            }}
          />
          <div className="mt-auto flex justify-center items-center gap-2">
            <button
              className="bg-blue-500 text-white-A700 px-4 py-2 rounded"
              onClick={() => {
                handleSubmit(submitObj);
              }}
            >
              Submit
            </button>
            <button
              className="bg-red-500 text-white-A700 px-4 py-2 rounded"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DebitNoteList;
